<div class="header">
  <div class="header-text">{{ title }}</div>
  <span class="close-image" (click)="close.emit()">&#10005;</span>
</div>
